import axios from 'axios';

export function stemParts(stem) {
  return String(stem || '').split('/').filter(Boolean);
}

export function allStems(pages) {
  const stems = new Set();
  pages.forEach((page) => {
    const parts = stemParts(page.stem);
    parts.forEach((_, i) => stems.add(parts.slice(0, i + 1).join('/')));
  });
  return [...stems].sort((a, b) => a.localeCompare(b));
}

export function pageSortKey(page) {
  const o = page && page.portal_order;
  const hasOrder = o !== null && o !== undefined && o !== '';
  return [hasOrder ? 0 : 1, hasOrder ? Number(o) : 0, String(page?.title || ''), Number(page?.id || 0)];
}

export function comparePages(a, b) {
  const ka = pageSortKey(a);
  const kb = pageSortKey(b);
  if (ka[0] !== kb[0]) return ka[0] - kb[0];
  if (ka[1] !== kb[1]) return ka[1] - kb[1];
  return ka[2].localeCompare(kb[2]) || (ka[3] - kb[3]);
}

export function childFolders(pages, parentStem) {
  const depth = stemParts(parentStem).length;
  const list = allStems(pages)
    .filter((stem) => stemParts(stem).length === depth + 1 && (!parentStem || stem.startsWith(`${parentStem}/`)))
    .map((stem) => {
      const under = pages.filter((p) => (p.stem || '') === stem || String(p.stem || '').startsWith(`${stem}/`));
      const orders = under.map((p) => p.portal_order).filter((o) => o !== null && o !== undefined && o !== '').map(Number);
      return { stem, name: stemParts(stem)[depth], order: orders.length ? Math.min(...orders) : null };
    });
  return list.sort((a, b) => {
    if (a.order !== null && b.order !== null && a.order !== b.order) return a.order - b.order;
    if (a.order !== null) return -1;
    if (b.order !== null) return 1;
    return a.name.localeCompare(b.name);
  });
}

export function folderPages(pages, stem) {
  return pages
    .filter((page) => (page.stem || '') === (stem || ''))
    .sort(comparePages);
}

export function breadcrumb(stem) {
  const parts = stemParts(stem);
  return parts.map((name, i) => ({ name, stem: parts.slice(0, i + 1).join('/') }));
}

export function folderOptions(pages, excludeStem = '') {
  return allStems(pages)
    .filter((stem) => !excludeStem || (stem !== excludeStem && !stem.startsWith(`${excludeStem}/`)))
    .map((stem) => ({ stem, depth: stemParts(stem).length - 1, label: stemParts(stem).slice(-1)[0] }));
}

export function pageUrl(page) {
  return `/pages/${page.id}`;
}

export function folderUrl(stem) {
  const parts = stemParts(stem);
  return parts.length ? `/pages/folder/${parts.map(encodeURIComponent).join('/')}` : '/pages';
}

export function domainFolder(name) {
  return String(name || '').replace(/\//g, '-').trim().slice(0, 60);
}

export async function domainStems() {
  const { data } = await axios.get('/api/performancedomains/');
  return data.map((domain) => domainFolder(domain.name));
}
